import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => {
        // Normalize language codes
        const normalized = lng.split('-')[0].toLowerCase();
        const supportedLngs = ['en', 'ko', 'vn'];
        return supportedLngs.includes(normalized) ? normalized : 'en';
      },
    },
    
    // Default namespace
    defaultNS: 'translation',
    
    // Supported languages
    supportedLngs: ['en', 'ko', 'vn'],
    
    // Disable loading for unsupported languages
    load: 'languageOnly',
    
    // Handle language detection fallback
    cleanCode: true,
    
    // Convert locales like 'en-US' to just 'en'
    nonExplicitSupportedLngs: true,
    
    // Resource loading options
    react: {
      useSuspense: false, // Disable suspense for better error handling
    },
    
    // Missing key handling
    saveMissing: process.env.NODE_ENV === 'development',
    missingKeyHandler: function(lng, ns, key, fallbackValue) {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing i18n key: ${lng}.${ns}.${key}`, fallbackValue);
      }
    },
  });

export default i18n;